import { Routes } from './router';
import { withProviders } from './providers';

export const App = withProviders(Routes);
